import { render, staticRenderFns } from "./CTA04.vue?vue&type=template&id=80f8f25c"
import script from "./CTA04.vue?vue&type=script&lang=js"
export * from "./CTA04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports